<template>

	<div>

		<section class="outer-pad">

			<Table 
				:headings="headings" 
				:items="table.items" 
				:pages="table.pages"
				:page="table.page"
				:count="table.count"
				:sorted="table.sorted"
				emptyLabel="No updates were found"
				:loading="!fetched"
				loadingText="Fetching updates..."
				addNewButtonLabel="Add new"
				@addNew="showModal=true"
				@edit="editUpdate"
				@delete="deleteUpdate"
			/>

		</section>

		<Modal 
			:class="{ 'dashboard-update': true }"
			:width="600"
			:title="title"
			:hasHeader="true"
			@close="close"
			v-if="showModal"
		>
			<template v-slot:content>
				<form class="form normal" @submit.prevent="saveSettings">
					<FormInput
						type="text"
						label="Title"
						v-model="settings.title"
					/>
					<FormInput
						type="text"
						label="Description"
						v-model="settings.text"
					/>
					<FormInput
						type="text"
						label="Link (optional)"
						v-model="settings.link"
					/>
					<VueCtkDateTimePicker
						v-model="settings.displayFrom"
						:label="'Display From'"
						color="#d20000"
						:no-label="true"
					/>

					<VueCtkDateTimePicker
						v-model="settings.displayTo"
						:label="'Display To'"
						color="#d20000"
						:no-label="true"
					/>
					<span
						class="large-button"
						@click="saveSettings"
						v-html="'Save'"
					/>
				</form>
			</template>
		</Modal>

	</div>

</template>

<script>
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex'
import general from './../../utils/general'
import ApiService from './../../services/api.service'
import Table from './../../components/Table.vue'
import TableButton from './../../components/Display/TableButton.vue'
import Modal from './../../components/Display/Modal.vue'
import FormInput from "./../../components/Form/Input.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
	name: 'DashboardUpdates',
	components: {
		Table,
		Modal,
		FormInput
	},
	data() {
		return {
			fetched: false,
			showModal: false,
			edit: null,
			settings: {
				title: '',
				text: '',
				link: '',
				displayFrom: '',
				displayTo: ''
			},
			table: {
				items:[],
				page: 1,
				pages: 1,
				sorted: {},
				search: {}
			}
		}
	},
	computed: {

		...mapState('general',['dateTimeFormat','dateFormat']),

		title () {

			return 'Add Update';

		},

		headings () {

			let headings = {
				title: { value: 'Title', alignHeading: 'left', alignCell: 'left' }, 
				displayFrom: { value: 'Display From', alignHeading: 'left', alignCell: 'left', dateFormat: this.dateFormat },
				displayTo: { value: 'Display To', alignHeading: 'left', alignCell: 'left', dateFormat: this.dateFormat },
				edit: { value: '', component: TableButton, event: 'edit', valueForFilter: 'Edit' },
				delete: { value: '', component: TableButton, event: 'delete', valueForFilter: 'Delete' }
			};

			return headings;

		}

	},
	methods: {

		...mapMutations('general',['updateLoadingText']),
		
		close() {
			this.edit = null;
			this.settings = {
				title: '',
				text: '',
				link: '',
				displayFrom: '',
				displayTo: ''
			};
			this.showModal = false;
		},

		loadUpdates () {

			this.updateLoadingText(true);

			ApiService.get ( 'admin/dashboard-updates' )
			.then( function( response ) {

				this.updateLoadingText();
				Vue.set( this, 'table', response.data );
				this.fetched = true;

			}.bind(this))
			.catch( function(err) {

				this.updateLoadingText();

			}.bind(this));

		},
		editUpdate ({_id}) {

			let s = this.table.items.find( item => item._id === _id );

			['displayFrom','displayTo','link','text','title'].forEach( function (key) {

				if ( s[key] ) this.settings[key] = s[key];

			}.bind(this));
			
			this.showModal = true;
			this.edit = _id;

		},
		deleteUpdate ({_id}) {

			this.$dialog
				.confirm( "Are you sure?", { okText: 'Yes', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText(true);

					ApiService.delete ( 'admin/dashboard-updates/' + _id )
					.then( function( response ) {

						this.close();
						this.loadUpdates();

						this.updateLoadingText();

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();

					}.bind(this));

				}.bind(this))
				.catch(function() {
					

				});

		},
		saveSettings () {
			let ok = true;

			Object.keys( this.settings ).forEach( function (key ) {
				if ( !this.settings[key] && key !== 'link' ) ok = false;
			}.bind(this));

			if ( !ok ) {

				this.$snotify.error( 'All fields except link are required.' );
				return;

			}
			this.updateLoadingText(true);

			ApiService[ this.edit ? 'put' : 'post' ] ( 'admin/dashboard-updates/' + ( this.edit || '' ), this.settings )
			.then( function( response ) {

				this.close();
				this.loadUpdates();
				this.updateLoadingText();

			}.bind(this))
			.catch( function(err) {

				this.updateLoadingText();

			}.bind(this));

		}
		
	},
	created() {

		this.loadUpdates ();

	}
}
</script>
